(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5986,2169,5512,8461],{

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 67309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage/whats-new/whats-new-page",
      function () {
        return __webpack_require__(83841);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgEarth = function SvgEarth(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    })), _path2 || (_path2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.831 18.737C6.613 16.95 5.8 13.707 5.8 10s.813-6.951 2.031-8.737M1 10h18M2.386 14.8h15.229M2.386 5.2h15.229M12.169 1.263C13.386 3.05 14.2 6.293 14.2 10s-.813 6.951-2.031 8.737"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEarth);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ HEADER_POPUP_OPTIONS; },
/* harmony export */   "Yq": function() { return /* binding */ HEADER_POPUP_DATA; }
/* harmony export */ });
/* unused harmony exports RING_THE_BELL_VALUE, IPO_BLOG_POST_VALUE, ELEVATE_REGISTRATION_VALUE, RING_THE_BELL_TEXT, IPO_BLOG_POST_TEXT, ELEVATE_REGISTRATION_TEXT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72632);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_localization__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);




var RING_THE_BELL_VALUE = "ring_the_bell";
var IPO_BLOG_POST_VALUE = "ipo_blog_post";
var ELEVATE_REGISTRATION_VALUE = "elevate_registration";
var RING_THE_BELL_TEXT = "Ring the bell";
var IPO_BLOG_POST_TEXT = "IPO blog post";
var ELEVATE_REGISTRATION_TEXT = "Elevate Registration";
var HEADER_POPUP_OPTIONS = [
    {
        value: RING_THE_BELL_VALUE,
        text: RING_THE_BELL_TEXT
    },
    {
        value: IPO_BLOG_POST_VALUE,
        text: IPO_BLOG_POST_TEXT
    },
    {
        value: ELEVATE_REGISTRATION_VALUE,
        text: ELEVATE_REGISTRATION_TEXT
    }
];
var CLOUDINARY_BELL_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/ipo/ipo-bell-gif.gif";
var ELEVATE_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/elevate/star-rect.gif";
var ELEVATE_MOBILE_IMAGE_SRC = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/elevate/star-static.png";
var getRingTheBellLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .RING_THE_BELL_VIDEO_LINK */ .Kk$;
};
var getIpoBlogPostLink = function(locale) {
    switch(locale){
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.SPANISH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_SPANISH_LINK */ .zjT;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.PORTUGEESE_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_PORTUGESE_LINK */ .aL4;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.GERMAN_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_GERMAN_LINK */ .mF0;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.FRENCH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_FRENCH_LINK */ .div;
        default:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_LINK */ .vWk;
    }
};
var getElevateRegitrationLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ELEVATE_MAIN_PAGE_LINK */ .Csm;
};
var _obj;
var HEADER_POPUP_DATA = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, RING_THE_BELL_VALUE, {
    textKey: "header.ipo.popup.ringTheBell.mainText",
    ctaKey: "header.ipo.popup.ringTheBell.cta",
    getLink: getRingTheBellLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, IPO_BLOG_POST_VALUE, {
    textKey: "header.ipo.popup.ipoBlogPost.mainText",
    ctaKey: "header.ipo.popup.ipoBlogPost.cta",
    getLink: getIpoBlogPostLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ELEVATE_REGISTRATION_VALUE, {
    textKey: "header.elevate.popup.mainText",
    mobileTextKey: "header.elevate.popup.mobileText",
    ctaKey: "header.elevate.popup.cta",
    getLink: getElevateRegitrationLink,
    popupClassName: "elevate",
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .GRADIANT_ELEVATE_THEME_ID */ .wk,
    gifSrc: ELEVATE_GIF_SRC,
    mobileImageSrc: ELEVATE_MOBILE_IMAGE_SRC
}), _obj);


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__);








var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 83841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ WhatsNewPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 116 modules
var base_header_component = __webpack_require__(77097);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
// EXTERNAL MODULE: ./components/pages/whats-new/whats-new-items-list-component/whats-new-items-list.js + 8 modules
var whats_new_items_list = __webpack_require__(1681);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/pages/whats-new/desktop/whats-new-page-layout-desktop-component.scss.js

var StyledWhatsNewPageLayoutDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1gjakyq0"
})(".whats-new-page-content{font-size:54px;text-align:center;.items-list-wrapper{display:flex;margin-top:40px;justify-content:center;}}");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.js + 1 modules
var full_paragraph_component = __webpack_require__(98461);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./components/pages/whats-new/consts.js
var consts = __webpack_require__(62972);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-mobile-second-fold/highlight-card/highlight-card-component.scss.js



var RELEASE_TYPE_BACKGROUND_COLOR = colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME];
var RELEASE_TYPE_TEXT_COLOR = colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME];
var StyledHighlightCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qw9m3w0"
})("display:flex;flex-direction:column;align-items:center;width:90%;.highlight-image{width:100%;height:auto;overflow:hidden;border-top-left-radius:8px;border-top-right-radius:8px;}.highlight-image img{width:100%;height:auto;object-fit:cover;}.card-content{border:1px solid ", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";border-color:", colors/* default.gainsboro */.Z.gainsboro, ";border-top:none;border-bottom-left-radius:8px;border-bottom-right-radius:8px;width:calc(100% - 1px);padding:12px;.release-type-wrapper{display:flex;margin-top:16px;margin-bottom:10px;}.release-type{font-size:0.75rem;border-radius:4px;display:flex;margin-right:8px;background-color:", RELEASE_TYPE_BACKGROUND_COLOR, ";flex-direction:row;color:", RELEASE_TYPE_TEXT_COLOR, ";padding:6px 12px;}.highlight-title{font-weight:600;font-size:1rem;padding:4px 8px 0px;text-align:left;line-height:26px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;/* number of lines to show */\n      -webkit-box-orient:vertical;}.highlight-description{font-size:0.75rem;padding:8px;padding-bottom:0;text-align:left;line-height:22px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:4;/* number of lines to show */\n      -webkit-box-orient:vertical;}.button-container{display:flex;justify-content:left;padding:8px 8px 16px;.secondary-button{.secondary-button-text{font-size:0.75rem;}}}.button-place-holder{height:48px;}}&.is-desktop{width:95%;border:1px solid #dcdfec;border-color:", colors/* default.gainsboro */.Z.gainsboro, ";border-radius:8px;:hover{box-shadow:0 0 16px rgba(29,140,242,0.16);}.card-content{border:none;border-color:none;.highlight-title{-webkit-line-clamp:1;}.highlight-description{-webkit-line-clamp:2;}}}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-mobile-second-fold/highlight-card/highlight-card-component.js





var HighlightCard = function(param) {
    var imageUrl = param.imageUrl, title = param.title, description = param.description, releaseType = param.releaseType, articleLink = param.articleLink, isDesktop = param.isDesktop;
    var _ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType;
    var BUTTON_TEXT = "Learn more";
    var releaseData = (_ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType = consts/* ID_TO_OPTIONS_NAMES_AND_COLORS.releaseType */.Wi.releaseType) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType === void 0 ? void 0 : _ID_TO_OPTIONS_NAMES_AND_COLORS_releaseType.data[releaseType];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHighlightCard, {
        className: classnames_default()("highlight-card", {
            "is-desktop": isDesktop
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "highlight-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageUrl,
                    alt: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-content",
                children: [
                    releaseType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "release-type-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "release-type",
                            children: releaseData === null || releaseData === void 0 ? void 0 : releaseData.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "highlight-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "highlight-description",
                        children: description
                    }),
                    articleLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, {
                            buttonText: BUTTON_TEXT,
                            withoutUnderline: true,
                            url: articleLink,
                            isOpenLinkInNewTab: true
                        })
                    }),
                    !articleLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button-place-holder"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var highlight_card_component = (HighlightCard);

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./components/pages/whats-new/whats-new-first-fold-consts.js


var fullParagraphConfig = {
    title: "What’s new",
    topic: {
        text: ""
    },
    titleColor: color_consts.WHITE_COLOR_NAME,
    titleSize: sizes/* XXL */.T3,
    body: "Discover the latest feature releases, improvements, and updates on web, desktop and mobile apps.",
    bodyColor: color_consts.WHITE_COLOR_NAME,
    textSize: sizes.LG,
    isFirstSegment: true
};
var blackTextFullParagraphConfig = {
    title: "What’s new",
    topic: {
        text: ""
    },
    titleColor: color_consts.BRAND_BLACK_TEXT_COLOR,
    titleSize: sizes.XL,
    body: "Discover the latest feature releases, improvements, and updates on web, desktop and mobile apps.",
    bodyColor: color_consts.BRAND_BLACK_TEXT_COLOR,
    textSize: sizes.LG,
    isFirstSegment: true
};
var assetConfig = {
    video: {
        src: {
            formats: [
                "/Generator_featured images/Whats new page/First_Fold-Whats_new.mp4"
            ]
        },
        loop: true,
        height: "480px"
    }
};

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/pages/whats-new/whats-new-first-fold-component/whats-new-first-fold-component.scss.js




var StyledWhatsNewFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e13hwj990"
})("padding-top:60px;display:flex;flex-direction:row;.left-space{min-width:calc((100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2);flex-grow:1;}position:relative;.left-section{width:40%;display:flex;flex-direction:column;.buttons-wrapper{display:flex;flex-direction:row;padding-left:32px;gap:20px;.circle-with-arrow{display:flex;width:35px;height:35px;border-radius:50%;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";position:relative;border:1px solid ", colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR], ";justify-content:center;align-items:center;font-size:1.75rem;padding-top:3px;cursor:default;:not(.first-slide):not(.last-slide):hover{color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR], ";cursor:pointer;}}}.full-paragraph-component{margin:100px 0 20px 0;}}.carousel-wrapper{width:60%;}.card{opacity:0;transition:opacity 0.5s ease-in-out;}.slick-slide.slick-active .card{opacity:1;}");

;// CONCATENATED MODULE: ./components/pages/whats-new/whats-new-first-fold-component/whats-new-first-fold-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var WhatsNewFirstFoldComponent = function(props) {
    var releaseHighlightsArray = props.releaseHighlightsArray;
    var ref = (0,react.useState)(0), currentSlide = ref[0], setCurrentSlide = ref[1];
    var sliderRef = (0,react.useRef)();
    var settings = {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        beforeChange: function(oldIndex, newIndex) {
            setCurrentSlide(newIndex);
        },
        infinite: false,
        initialSlide: 0
    };
    var next = function() {
        currentSlide !== releaseHighlightsArray.length - 2 && sliderRef.current.slickNext();
    };
    var previous = function() {
        currentSlide !== 0 && sliderRef.current.slickPrev();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhatsNewFirstFoldComponent, {
        className: "whats-new-first-fold-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "left-space"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph_component["default"], _object_spread({}, blackTextFullParagraphConfig)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "buttons-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("circle-with-arrow", {
                                    "first-slide": currentSlide === 0
                                }),
                                onClick: previous,
                                children: "<"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("circle-with-arrow", {
                                    "last-slide": currentSlide === releaseHighlightsArray.length - 2
                                }),
                                onClick: next,
                                children: ">"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, _object_spread_props(_object_spread({
                    ref: sliderRef
                }, settings), {
                    children: [
                        releaseHighlightsArray.map(function(highlight, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "card",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(highlight_card_component, {
                                    imageUrl: highlight.cloudinaryUrl,
                                    title: highlight.title,
                                    description: highlight.shortText,
                                    releaseType: highlight.releaseType,
                                    articleLink: highlight.articleLink,
                                    isDesktop: true
                                })
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    ]
                }))
            })
        ]
    });
};
/* harmony default export */ var whats_new_first_fold_component = (WhatsNewFirstFoldComponent);

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-desktop-component/use-cases-tabs-desktop-component.js + 3 modules
var use_cases_tabs_desktop_component = __webpack_require__(9306);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./components/pages/whats-new/desktop/whats-new-apps-section/whats-new-apps-section.scss.js




var StyledWhatsNewAppsSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eywf3ra0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding-left:2vw;.subtle-line{border:0;border-top:1px solid;border-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";margin:40px 0;}.title-wrapper{text-align:left;margin-top:20px;margin-bottom:20px;.core-title-container .core-title{font-size:1.5rem;font-weight:300;}}.tabs-wrapper{.use-cases-tabs-component{align-items:baseline;.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border-color:", color_consts.BRAND_BLACK_BACKGROUND_COLOR, ";&:hover{border-color:", color_consts.BRAND_BLACK_BACKGROUND_COLOR, ";color:", color_consts.BRAND_BLACK_TEXT_COLOR, ";background-color:transparent;}&.selected{background-color:", color_consts.BRAND_BLACK_BACKGROUND_COLOR, ";&:hover{border-color:", color_consts.BRAND_BLACK_BACKGROUND_COLOR, ";color:", color_consts.WHITE_COLOR_NAME, ";background-color:", color_consts.BRAND_BLACK_BACKGROUND_COLOR, ";}}}}.carousel-wrapper{width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;padding-left:1vw;@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){padding-left:0;}.carousel{.use-case-tab-content{padding:0;}}}.use-case-tab-content{padding-left:0;height:120px;.app-section{max-height:200px;display:flex;flex-wrap:wrap;flex-direction:column;a{all:unset;}.app{display:flex;flex-direction:row;gap:20px;margin-bottom:30px;cursor:pointer;.app-image-wrapper{width:60px;.asset-inner .picture-component img{border-radius:12px;}}.text-wrapper{display:flex;flex-direction:column;text-align:left;justify-content:center;.app-title{font-size:0.875rem;font-weight:700;line-height:21px;}.app-description{font-size:0.875rem;font-weight:300;line-height:21px;width:260px;}}}}}}}");

;// CONCATENATED MODULE: ./components/pages/whats-new/desktop/whats-new-apps-section/whats-new-apps-section.js






var WhatsNewAppsSection = function(props) {
    var appsSet = props.appsSet;
    var tabs = [
        appsSet[consts/* APPS_NEW */.kh],
        appsSet[consts/* APPS_RECOMMENDED */.$M],
        appsSet[consts/* APPS_TRENDING */._g]
    ];
    var APPS_TITLE = "Marketplace app highlights";
    var renderApps = function(apps) {
        var _apps_content;
        return apps === null || apps === void 0 ? void 0 : (_apps_content = apps.content) === null || _apps_content === void 0 ? void 0 : _apps_content.map(function(app) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                href: app === null || app === void 0 ? void 0 : app.articleLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "app",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "app-image-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                                image: {
                                    src: app === null || app === void 0 ? void 0 : app.cloudinaryUrl
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "app-title",
                                    children: app.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "app-description",
                                    children: app.shortText
                                })
                            ]
                        })
                    ]
                })
            });
        });
    };
    var itemRenderer = function(tab) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "use-case-tab-content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "app-section",
                apps: tab,
                children: renderApps(tab)
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhatsNewAppsSection, {
        className: "whats-new-apps-section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "subtle-line",
                style: {
                    marginBottom: "40px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                    title: APPS_TITLE
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tabs-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(use_cases_tabs_desktop_component/* default */.Z, {
                    tabs: tabs,
                    replacementItemRenderer: itemRenderer,
                    hideArrows: true,
                    disableDraggable: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "subtle-line"
            })
        ]
    });
};
/* harmony default export */ var whats_new_apps_section = (WhatsNewAppsSection);

;// CONCATENATED MODULE: ./components/pages/whats-new/desktop/whats-new-page-layout-desktop-component.js







var WhatsNewPageLayoutDesktopComponent = function(props) {
    var itemsArray = props.itemsArray, releaseHighlightsArray = props.releaseHighlightsArray, monthlyVideosSet = props.monthlyVideosSet, appsSet = props.appsSet;
    var slicedReleaseHighlightsArray = releaseHighlightsArray.slice(0, 6);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhatsNewPageLayoutDesktopComponent, {
        className: "whats-new-page-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "whats-new-page-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "first-fold-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_first_fold_component, {
                            releaseHighlightsArray: slicedReleaseHighlightsArray
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whats-new-apps-section-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_apps_section, {
                            appsSet: appsSet
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "items-list-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_items_list/* default */.Z, {
                            itemsArray: itemsArray,
                            monthlyVideosSet: monthlyVideosSet
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {})
        ]
    });
};
/* harmony default export */ var whats_new_page_layout_desktop_component = (WhatsNewPageLayoutDesktopComponent);

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-mobile-first-fold/whats-new-mobile-first-fold-component.scss.js


var StyledWhatsNewMobileFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1x2f4ah0"
})("display:grid;grid-template-rows:1fr;grid-template-columns:1fr;.asset-wrapper{grid-row:1 / 2;grid-column:1 / 2;position:relative;.dark-overlay{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.7);z-index:", z_index/* TOP_LAYER */.nA, ";}.asset-inner{height:100%;.picture-component{display:flex;height:100%;}}}.content-wrapper{grid-row:1 / 2;grid-column:1 / 2;z-index:", z_index/* LAYER_ONE */.KW, ";display:flex;flex-direction:column;align-items:flex-start;justify-content:center;padding:40px 24px;text-align:left;.core-title-container .core-title{font-weight:700;margin-bottom:16px;font-size:2.25rem;}.paragraph-wrapper .paragraph-body{font-size:1rem;font-weight:500;line-height:28px;}}");

;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-mobile-first-fold/whats-new-mobile-first-fold-component.js






var WhatsNewMobileFirstFoldComponent = function() {
    var title = fullParagraphConfig.title, body = fullParagraphConfig.body, titleColor = fullParagraphConfig.titleColor, bodyColor = fullParagraphConfig.bodyColor;
    var FIRST_FOLD_IMAGE_URL = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/mobile_first_fold.png";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhatsNewMobileFirstFoldComponent, {
        className: "whats-new-mobile-first-fold",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "asset-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                        image: {
                            src: FIRST_FOLD_IMAGE_URL
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dark-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                        title: title,
                        titleColor: titleColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: body,
                        bodyColor: bodyColor
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var whats_new_mobile_first_fold_component = (WhatsNewMobileFirstFoldComponent);

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-mobile-second-fold/whats-new-mobile-second-fold-component.scss.js



var StyledWhatsNewMobileSecondFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1l624550"
})("padding:0 0 48px 12px;.title-wrapper{margin:40px 10px 20px;.core-title-container .core-title{font-size:1.75rem;font-weight:600;}}.carousel-wrapper .carousel .slick-slider .slick-dots{li button{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";border:1px solid;border-color:", colors/* default.mud */.Z.mud, ";}li.slick-active button{background-color:", colors/* default.mud */.Z.mud, ";}}.carousel-wrapper .carousel .slick-slider.focus .slick-list .slick-track .slick-slide .carousel-item{opacity:1;}");

;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-mobile-second-fold/whats-new-mobile-second-fold-component.js
function whats_new_mobile_second_fold_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function whats_new_mobile_second_fold_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            whats_new_mobile_second_fold_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var WhatsNewMobileSecondFoldComponent = function(props) {
    var releaseHighlightsArray = props.releaseHighlightsArray;
    var slicedReleaseHighlightsArray = releaseHighlightsArray.slice(0, 6);
    var itemRenderer = function(highlight) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "highlight-card-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(highlight_card_component, {
                imageUrl: highlight.cloudinaryUrl,
                title: highlight.title,
                description: highlight.shortText,
                releaseType: highlight.releaseType,
                articleLink: highlight.articleLink
            })
        });
    };
    var carouselProps = {
        items: slicedReleaseHighlightsArray,
        itemRenderer: itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        centerPadding: "10%",
        focusAfterSwipe: true,
        disableSlideOnStartClick: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhatsNewMobileSecondFoldComponent, {
        className: "whats-new-mobile-second-fold",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                    title: "Release highlights"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, whats_new_mobile_second_fold_component_object_spread({}, carouselProps))
            })
        ]
    });
};
/* harmony default export */ var whats_new_mobile_second_fold_component = (WhatsNewMobileSecondFoldComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./static/svg/close.svg
var svg_close = __webpack_require__(1725);
// EXTERNAL MODULE: ./components/pages/whats-new/utils.js
var utils = __webpack_require__(29621);
;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/mobile-filters/mobile-filters-component.scss.js




var FILTER_BLUE = "#0073ea";
var SUBTLE_LINE_COLOR = "#e1e1e1";
var FILTER_OPTION_SELECTED_COLOR = "#cce5ff";
var StyledMobileFiltersComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1cnua4i0"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";.modal-content{background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";width:100%;height:100%;overflow-y:auto;}.filters-section{margin-bottom:100px;}.top-bar{align-items:center;position:sticky;top:0;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";z-index:", z_index/* ALWAYS_ON_TOP */.OL + 1, ";}.top-bar-content{display:flex;justify-content:space-between;align-items:center;width:100%;padding:16px 8px;}.close-button{padding:0 62px 0 12px;}.filter-title{margin:0;font-weight:500;}.subtle-line{border:0;border-top:1px solid;border-color:", SUBTLE_LINE_COLOR, ";}.filter-header{display:flex;justify-content:space-between;align-items:center;padding:16px;span{font-weight:600;}&.has-selected{span{color:", FILTER_BLUE, ";}}}.filter-content{margin-bottom:12px;.option{display:flex;flex-direction:row;font-size:1rem;padding:12px;font-weight:400;margin-bottom:4px;.icon{width:20px;height:20px;margin-right:8px;}&.selected{background-color:", FILTER_OPTION_SELECTED_COLOR, ";color:", FILTER_BLUE, ";padding:12px;border-radius:8px;box-sizing:border-box;}}}.down-arrow-wrapper{width:14px;height:14px;margin-right:12px;transition:transform 0.3s ease-in-out;}.down-arrow-wrapper.open{transform:rotate(180deg);position:relative;}.down-arrow{width:100%;height:100%;}.clear-button{color:", colors/* default.mud */.Z.mud, ";cursor:not-allowed;padding:0 12px;}.clear-button.active{color:", FILTER_BLUE, ";cursor:pointer;}.bottom-bar{display:flex;flex-direction:column;justify-content:center;align-items:center;position:absolute;bottom:0;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";z-index:", z_index/* ALWAYS_ON_TOP */.OL + 1, ";width:100%;}.apply-button{width:80%;margin:12px 0 24px;background-color:", colors/* default.gainsboro */.Z.gainsboro, ";color:", colors/* default.mud */.Z.mud, ";border-radius:8px;text-align:center;padding:16px 0;&.active{background-color:", FILTER_BLUE, ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";cursor:pointer;}}");

// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/mobile-filters/mobile-filters-component.js



function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_filters_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function mobile_filters_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_filters_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_filters_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var MobileFiltersComponent = function(param) {
    var isOpen = param.isOpen, closeModal = param.closeModal, setMobileFilterValues = param.setMobileFilterValues, itemsArray = param.itemsArray, setScrollToItemsList = param.setScrollToItemsList, setSelectedFilterCount = param.setSelectedFilterCount;
    var ref = (0,react.useState)({}), filters = ref[0], setFilters = ref[1];
    var ref1 = (0,react.useState)({}), openFilters = ref1[0], setOpenFilters = ref1[1];
    var handleMobileFiltersApply = function() {
        setMobileFilterValues(filters);
        setSelectedFilterCount(Object.values(filters).reduce(function(acc, cur) {
            return acc + cur.length;
        }, 0));
        setScrollToItemsList(true);
        closeModal();
    };
    var toggleFilter = function(id) {
        setOpenFilters(function(prevState) {
            return mobile_filters_component_object_spread_props(mobile_filters_component_object_spread({}, prevState), (0,src_define_property/* default */.Z)({}, id, !prevState[id]));
        });
    };
    var cleanedFiltersSchema = (0,react.useMemo)(function() {
        return (0,utils/* getCleanedFilterSchema */.Cm)(consts/* filtersSchema */.X8, itemsArray);
    }, [
        itemsArray
    ]);
    var handleSelect = function(filterId, value) {
        setFilters(function(prevState) {
            var _prevState_filterId;
            return mobile_filters_component_object_spread_props(mobile_filters_component_object_spread({}, prevState), (0,src_define_property/* default */.Z)({}, filterId, ((_prevState_filterId = prevState[filterId]) === null || _prevState_filterId === void 0 ? void 0 : _prevState_filterId.includes(value)) ? prevState[filterId].filter(function(v) {
                return v !== value;
            }) : (0,_to_consumable_array/* default */.Z)(prevState[filterId] || []).concat([
                value
            ])));
        });
    };
    var closeButtonClicked = function() {
        handleMobileFiltersApply();
        closeModal();
    };
    var clearAll = function() {
        setFilters({});
        setSelectedFilterCount(0);
    };
    var isFilterApplied = (0,react.useMemo)(function() {
        return Object.keys(filters).some(function(key) {
            return filters[key].length > 0;
        });
    }, [
        filters
    ]);
    (0,react.useEffect)(function() {
        if (!isOpen) {
            setOpenFilters({});
        }
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileFiltersComponent, {
        className: "mobile-filters-modal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "modal-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "top-bar",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "top-bar-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "close-button",
                                    onClick: closeButtonClicked,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_close/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "filter-title",
                                    children: "Filter"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "clear-button ".concat(isFilterApplied ? "active" : ""),
                                    onClick: isFilterApplied ? clearAll : null,
                                    children: "Clear All"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "subtle-line"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "filters-section",
                    children: cleanedFiltersSchema.map(function(filter, index) {
                        var _filters_filter_id;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "filter",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "filter-header ".concat(((_filters_filter_id = filters[filter.id]) === null || _filters_filter_id === void 0 ? void 0 : _filters_filter_id.length) > 0 && !openFilters[filter.id] ? "has-selected" : ""),
                                    onClick: function() {
                                        return toggleFilter(filter.id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: filter.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "down-arrow-wrapper ".concat(openFilters[filter.id] ? "open" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                                                className: "down-arrow"
                                            })
                                        })
                                    ]
                                }),
                                openFilters[filter.id] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "filter-content",
                                    children: Object.entries(filter.data).map(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), optionId = _param[0], optionData = _param[1];
                                        var _filters_filter_id;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "option ".concat(((_filters_filter_id = filters[filter.id]) === null || _filters_filter_id === void 0 ? void 0 : _filters_filter_id.includes(optionId)) ? "selected" : ""),
                                            onClick: function() {
                                                return handleSelect(filter.id, optionId);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "icon",
                                                    children: (0,utils/* getFilterIcon */.zT)(optionData.name)
                                                }),
                                                optionData.name
                                            ]
                                        }, optionId);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "subtle-line"
                                })
                            ]
                        }, filter.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bottom-bar",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "subtle-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "apply-button ".concat(isFilterApplied ? "active" : ""),
                            onClick: isFilterApplied ? handleMobileFiltersApply : null,
                            children: "Apply"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_filters_component = (MobileFiltersComponent);

;// CONCATENATED MODULE: ./static/svg/filter.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgFilter = function SvgFilter(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 28,
        height: 30,
        fill: "none",
        viewBox: "0 0 28 30"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.819,
        d: "M2.325 7.884H25.57M6.974 14.554h13.948M10.46 21.225h6.975"
    })));
};
/* harmony default export */ var filter = (SvgFilter);

;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-page-layout-mobile-component.scss.js




var FILTER_BUTTON_COLOR = "#cce5ff";
var StyledWhatsNewPageLayoutMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e110wbo90"
})(".items-list-title-wrapper{margin:44px 24px 0;.core-title-container .core-title{font-size:1.5rem;font-weight:500;}}.filter-button-wrapper{box-shadow:0px 4px 6px rgba(29,140,242,0.1);margin-bottom:24px;position:sticky;top:64px;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";z-index:", z_index/* LAYER_ONE */.KW, ";.filter-button{display:inline-flex;flex-direction:row;background-color:", FILTER_BUTTON_COLOR, ";padding:4px 8px;border-radius:4px;font-size:1.25rem;font-weight:bold;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";text-align:center;cursor:pointer;margin-bottom:20px;margin:24px;}.filter-icon-wrapper{margin-right:4px;margin-top:4px;svg{height:28px;}}.filter-text{display:flex;align-items:center;font-weight:500;}}&.no-scroll{overflow:hidden;position:fixed;height:100%;width:100%;}");

;// CONCATENATED MODULE: ./components/pages/whats-new/mobile/whats-new-page-layout-mobile-component.js











var WhatsNewPageLayoutMobileComponent = function(props) {
    var itemsArray = props.itemsArray, releaseHighlightsArray = props.releaseHighlightsArray;
    var ref = (0,react.useState)(""), searchInput = ref[0], setSearchInput = ref[1];
    var ref1 = (0,react.useState)(false), isFilterModalOpen = ref1[0], setIsFilterModalOpen = ref1[1];
    var ref2 = (0,react.useState)({}), mobileFilterValues = ref2[0], setMobileFilterValues = ref2[1];
    var ref3 = (0,react.useState)(0), selectedFilterCount = ref3[0], setSelectedFilterCount = ref3[1];
    var itemsListRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(false), scrollToItemsList = ref4[0], setScrollToItemsList = ref4[1];
    var handleSearchInputChange = function(e) {
        setSearchInput(e.target.value);
    };
    var handleFilterButtonClick = function() {
        setIsFilterModalOpen(true);
    };
    var closeModal = function() {
        setIsFilterModalOpen(false);
    };
    (0,react.useEffect)(function() {
        if (scrollToItemsList) {
            var offsetTop = itemsListRef.current.offsetTop;
            var headerOffset = 200;
            window.scrollTo({
                top: offsetTop - headerOffset,
                behavior: "smooth"
            });
            setScrollToItemsList(false);
        }
    }, [
        scrollToItemsList,
        setScrollToItemsList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWhatsNewPageLayoutMobileComponent, {
        className: "whats-new-mobile-page-component".concat(isFilterModalOpen ? " no-scroll" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "whats-new-mobile-page-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "first-fold-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_mobile_first_fold_component, {
                            handleSearchInputChange: handleSearchInputChange
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "second-fold-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_mobile_second_fold_component, {
                            releaseHighlightsArray: releaseHighlightsArray
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "items-list-title-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                            title: "All Updates & Releases"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter-button-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "filter-button",
                            onClick: handleFilterButtonClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "filter-icon-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "filter-text",
                                    children: [
                                        " Filter ",
                                        selectedFilterCount > 0 && "(".concat(selectedFilterCount, ")")
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "items-list-wrapper",
                        ref: itemsListRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_items_list/* default */.Z, {
                            itemsArray: itemsArray,
                            textSearch: searchInput,
                            filterValues: mobileFilterValues,
                            isMobile: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_filters_component, {
                        isOpen: isFilterModalOpen,
                        closeModal: closeModal,
                        setMobileFilterValues: setMobileFilterValues,
                        itemsArray: itemsArray,
                        setScrollToItemsList: setScrollToItemsList,
                        setSelectedFilterCount: setSelectedFilterCount
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {})
        ]
    });
};
/* harmony default export */ var whats_new_page_layout_mobile_component = (WhatsNewPageLayoutMobileComponent);

;// CONCATENATED MODULE: ./components/pages/whats-new/whats-new-page-layout-component.js



var WhatsNewPageLayoutComponent = (0,responsive_hoc_component/* default */.Z)(whats_new_page_layout_desktop_component, whats_new_page_layout_mobile_component);
/* harmony default export */ var whats_new_page_layout_component = (WhatsNewPageLayoutComponent);

// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./components/templates/base-template.js + 72 modules
var base_template = __webpack_require__(69278);
;// CONCATENATED MODULE: ./services/whats-new-page/whats-new-page-config-service.js
var getWhatsNewPageConfig = function() {
    return {
        withFullstory: true,
        enableHotjar: true,
        fullstoryRecordingFrequency: 25,
        hotjarFinalDate: new Date(2024, 4, 1)
    };
};

// EXTERNAL MODULE: ./pages/generated-templates/base-template-page.js
var base_template_page = __webpack_require__(79813);
// EXTERNAL MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/consts.js
var whats_new_items_list_embedded_consts = __webpack_require__(10055);
;// CONCATENATED MODULE: ./pages/homepage/whats-new/whats-new-page.js






function whats_new_page_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function whats_new_page_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            whats_new_page_define_property(target, key, source[key]);
        });
    }
    return target;
}
function whats_new_page_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function whats_new_page_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        whats_new_page_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var TITLE = "What's New - monday.com Product Updates";
var DESCRIPTION = "Find out what's new on monday.com products including feature releases, upgrades, and resources. Explore product updates by teams and benefits in a few clicks.";
var WhatsNewPage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_inherits/* default */.Z)(WhatsNewPage, BaseTemplatePage);
    var _super = (0,_create_super/* default */.Z)(WhatsNewPage);
    function WhatsNewPage() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, WhatsNewPage);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        whats_new_page_define_property((0,_assert_this_initialized/* default */.Z)(_this), "buildMetaTags", function() {
            return {
                title: TITLE,
                description: DESCRIPTION
            };
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(WhatsNewPage, [
        {
            key: "render",
            value: function render() {
                var _mondayConfigToUse_data_boards__items_page, _mondayConfigToUse_data_boards_, _mondayConfigToUse_data_boards, _mondayConfigToUse_data;
                var _this_props = this.props, statusCode = _this_props.statusCode, props = _object_without_properties(_this_props, [
                    "statusCode"
                ]);
                var mondayConfig = props.mondayConfig, baseTemplateProps = _object_without_properties(props, [
                    "mondayConfig"
                ]);
                if (statusCode !== 200) return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
                    statusCode: statusCode
                });
                var mondayConfigToUse = mondayConfig || whats_new_items_list_embedded_consts/* staticMondayConfig */.f;
                var items = mondayConfigToUse === null || mondayConfigToUse === void 0 ? void 0 : (_mondayConfigToUse_data = mondayConfigToUse.data) === null || _mondayConfigToUse_data === void 0 ? void 0 : (_mondayConfigToUse_data_boards = _mondayConfigToUse_data.boards) === null || _mondayConfigToUse_data_boards === void 0 ? void 0 : (_mondayConfigToUse_data_boards_ = _mondayConfigToUse_data_boards[0]) === null || _mondayConfigToUse_data_boards_ === void 0 ? void 0 : (_mondayConfigToUse_data_boards__items_page = _mondayConfigToUse_data_boards_.items_page) === null || _mondayConfigToUse_data_boards__items_page === void 0 ? void 0 : _mondayConfigToUse_data_boards__items_page.items;
                var itemsArrayObj = (0,utils/* createItemsArray */.Su)(items);
                var itemsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.itemsArray) || [];
                var releaseHighlightsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.releaseHighlightsArray) || [];
                var monthlyVideosSet = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.monthlyVideosSet) || {};
                var appsSet = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.appsSet) || {};
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, whats_new_page_object_spread_props(whats_new_page_object_spread({}, baseTemplateProps, getWhatsNewPageConfig(), this.buildMetaTags()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_page_layout_component, {
                        itemsArray: itemsArray,
                        releaseHighlightsArray: releaseHighlightsArray,
                        monthlyVideosSet: monthlyVideosSet,
                        appsSet: appsSet
                    })
                }));
            }
        }
    ]);
    return WhatsNewPage;
}(base_template_page["default"]);
var __N_SSP = true;



/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 55408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LongFooterComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.scss.js

var StyledLongFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rc6ysx0"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var LongFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongFooterComponent);
    function LongFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, LongFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLongFooterComponent, {
                    className: "long-footer-component",
                    id: element_ids/* FOOTER_ID */.D,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer/* default */.Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return LongFooterComponent;
}(react.PureComponent);

LongFooterComponent.defaultProps = {};


/***/ }),

/***/ 98461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FullParagraphComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var default_props = __webpack_require__(7484);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.scss.js



var StyledFullParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej9vftf0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.full-paragraph-wrapper{max-width:1100px;margin:auto;display:flex;justify-content:center;padding:0px ", full_paragraph/* PARAGRAPH_HORIZONTAL_PADDING_STRING */.xe, ";}");

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var FullParagraphComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullParagraphComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullParagraphComponent);
    function FullParagraphComponent() {
        (0,_class_call_check/* default */.Z)(this, FullParagraphComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FullParagraphComponent, [
        {
            key: "render",
            value: function render() {
                var maxWidth = this.props.maxWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFullParagraphComponent, {
                    className: "full-paragraph-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "full-paragraph-wrapper",
                        style: {
                            maxWidth: maxWidth
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return FullParagraphComponent;
}(react.PureComponent);

FullParagraphComponent.defaultProps = _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.MD,
    textSize: sizes.MD,
    maxWidth: "1100px"
});


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ }),

/***/ 5512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ scrollIntoViewWithOffset; },
/* harmony export */   "l": function() { return /* binding */ isEventTargetSpecificTag; }
/* harmony export */ });
var isEventTargetSpecificTag = function(event, tagName) {
    return event.target.tagName.toUpperCase() === tagName.toUpperCase();
};
var scrollIntoViewWithOffset = function(ref, offset) {
    window.scrollTo({
        behavior: "smooth",
        top: (ref === null || ref === void 0 ? void 0 : ref.current.getBoundingClientRect().top) - document.body.getBoundingClientRect().top - offset
    });
};


/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6600,4506,9160,9861,4363,9278,1373,53,7097,9306,3966,9774,2888,179], function() { return __webpack_exec__(67309); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);